import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import { LanguageControllerService } from "../../services/language-controller/language-controller.service";
import {Store} from "../../services/store.service";

@Component({
    selector: "formio-dynamic-validation",
    templateUrl: "./formio-dynamic-validation.component.html",
    styleUrls: ["./formio-dynamic-validation.component.scss"],
    providers: [],
})
export class FormioDynamicValidationComponent implements OnInit {

    public serviceId: string;
    public componentKey: string;
    public componentValidationId: string;
    public subTab: string;

    constructor(private route: ActivatedRoute, public store: Store, public translate: TranslateService,
                private languageService: LanguageControllerService) {
        translate.setDefaultLang(store.state.common.lang);
        languageService.getLanguages().subscribe(
          (data) => {
            translate.addLangs(data.map((l) => l.code));
          });
    }

    public ngOnInit() {
        this.route.params.subscribe((params) => {
            this.serviceId = params.serviceId;
            this.subTab = params.subTab;
            this.store.state.common.serviceId = params.serviceId;
        });
        this.route.queryParamMap.subscribe((queryParams) => {
            this.componentKey = queryParams.get("key");
            this.componentValidationId = queryParams.get("componentValidationId");
        });
    }
}
